module.exports = __webpack_public_path__ + "static/media/bell-school-slash.ab2eab24.svg";